import React from 'react';
import { ExternalLink, Phone, MessageSquare, FileText } from 'lucide-react';
export function LinksAndResources() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1038" data-mp="phnvptmfk1w5">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1039" data-mp="uffxrggsh4e2">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-1040" data-mp="zeskm17nubgn">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-1041" data-mp="zgn4rdb3xzjo">
            LINKS & RESOURCES
          </h1>
        </div>

        {/* ADRE and other Useful Links Section */}
        <div className="mb-12" data-id="element-1042" data-mp="18eyvdfbz4xc4">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1043" data-mp="18dxh71znvuq6">
            ADRE and other Useful Links
          </h2>

          {/* Student Log-In Link */}
          <div className="mb-6" data-id="element-1044" data-mp="1i5tewbxu5itv">
            <p className="text-base" data-id="element-1045" data-mp="1i50dzrlk5njn">
              <span className="text-green-600 font-bold italic" data-id="element-1046" data-mp="1n4mr811dz3sg">
                Go Back To Student Log-In
              </span>{' '}
              <a href="http://www.desertsageseminars.com/Home.html" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline" data-id="element-1047" data-mp="1r79rmqc4hx19">
                http://www.desertsageseminars.com/Home.html
              </a>
            </p>
          </div>

          {/* ADRE */}
          <div className="mb-6" data-id="element-1048" data-mp="21rwtdzsfx3u7">
            <p className="text-base font-bold italic" data-id="element-1049" data-mp="21sonf66e2tid">
              Arizona Department of Real Estate (ADRE)
            </p>
          </div>
        </div>

        {/* QUESTIONS FOR ADRE Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-1050" data-mp="2uhdhil911ykm">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1051" data-mp="2poaoce85wr4y">
            QUESTIONS FOR ADRE?
          </h2>

          <div className="space-y-6" data-id="element-1052" data-mp="2kppwp36z7fs4">
            {/* Best way to communicate with ADRE */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1053" data-mp="3i6eveo0mq1xa">
              <p className="text-base text-gray-900 break-words" data-id="element-1054" data-mp="3df6j9k7x02gf">
                Best way to communicate with ADRE is through their Message
                Center:{' '}
                <a href="https://azre.gov/contact-us/message-center" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline break-all" data-id="element-1055" data-mp="1bjqoy0gpq8lv">
                  https://azre.gov/contact-us/message-center
                </a>
              </p>
            </div>

            {/* Find Your License Number */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1056" data-mp="ws8a45zlak43">
              <p className="text-base font-bold italic mb-2" data-id="element-1057" data-mp="wqdpytw56w12">
                *Find Your License Number
              </p>
              <a href="http://services.azre.gov/publicdatabase/SearchIndividuals.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1058" data-mp="nrsd9fdcqb87">
                http://services.azre.gov/publicdatabase/SearchIndividuals.aspx
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1059" data-mp="6izgc366tuhy" />
              </a>
            </div>

            {/* Enter CE Classes */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1060" data-mp="1hjxmhrhg02q">
              <p className="text-base font-bold italic mb-2" data-id="element-1061" data-mp="g92kmzireuvl">
                *Report CE Classes To ADRE
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-1062" data-mp="bfhjwzps7msp">
                (have your license number ready to create or log in to account):
              </p>
              <a href="/How_To_Add_CE_Classes" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1063" data-mp="kanwchjk5347">
                View Reporting Instructions
              </a>
            </div>

            {/* ADRE Fee Schedule */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1064" data-mp="30y00rsukk2ts">
              <p className="text-base font-bold italic mb-2" data-id="element-1065" data-mp="310m9vwx3yqe4">
                *Fees to renew AZ real estate license:
              </p>
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1066" data-mp="1n3029ws3pdvt">
                https://azre.gov/all-adre-resources/fees
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1067" data-mp="212j6iehsk52u" />
              </a>
            </div>

            {/* Log in or update */}
            <div data-id="element-1068" data-mp="14djx2w5h0x92">
              <p className="text-base font-bold italic mb-2" data-id="element-1069" data-mp="149w88aaz0z0o">
                *Log in or update your personal information at ADRE or :
              </p>
              <a href="https://ptl.az.gov/app/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1070" data-mp="1dbm7g2b3h290">
                https://ptl.az.gov/app/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1071" data-mp="pmb4ce69uvrp" />
              </a>
            </div>
          </div>
        </div>

        {/* Tech Helpline Section */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1072" data-mp="i17k5zg7klca">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-6" data-id="element-1073" data-mp="d5a0pk9neyva">
            Tech Helpline
          </h2>

          <div className="space-y-4" data-id="element-1074" data-mp="94zwac1i8gij">
            <p className="text-lg text-gray-900" data-id="element-1075" data-mp="44bxv5ay4xea">
              Did you know that you can get tech help for ALL of your devices?
            </p>
            <p className="text-lg text-gray-900 ml-10" data-id="element-1076" data-mp="3vbenhsb4yvme">
              It's "free"... paid for with your{' '}
              <strong data-id="element-1077" data-mp="3qhafr6u1qjk9">
                REALTOR<sup data-id="element-1078" data-mp="3lk0tg01yeo0n">®</sup>
              </strong>{' '}
              dues!
            </p>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1079" data-mp="3hip2nr7cfwqv">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1080" data-mp="3hk9sj3ipqrie">
                Contact Tech HelpLine:
              </p>
              <div className="space-y-2" data-id="element-1081" data-mp="3clgffc7c92ir">
                <p className="text-base text-gray-900" data-id="element-1082" data-mp="37k9b5n4emlgu">
                  <strong data-id="element-1083" data-mp="37mvh5ibncswy">Phone:</strong> (866) 232-1791
                </p>
                <p className="text-base text-gray-900" data-id="element-1084" data-mp="2xvlrzyg71ti8">
                  <strong data-id="element-1085" data-mp="32w9v3ihp60st">Online chat or support:</strong>{' '}
                  <a href="http://chat.techhelpline.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-1086" data-mp="32tndeq13e4wv">
                    http://chat.techhelpline.com
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1087" data-mp="3llpzigwi6dei">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1088" data-mp="36wjzwrtr6l63">Hours:</p>
              <div className="space-y-1" data-id="element-1089" data-mp="3bw6cr05o5zed">
                <p className="text-base text-gray-900" data-id="element-1090" data-mp="3bv3okzzqeb25">
                  Monday through Friday—9 am to 8 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1091" data-mp="87l8rq7yspep">
                  Saturday—9 am to 5 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1092" data-mp="1sx8j4nbanfs7">Sunday—closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Residential Landlord/Tenant Act Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-1093" data-mp="22o329it8tz9f">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1094" data-mp="1xo6z1lsdebux">
            <a href="https://housing.az.gov/sites/default/files/documents/files/Landlord_Tenant_Act_May-2023_1.pdf" target="_blank" rel="noopener noreferrer" className="text-[#fcb53d] hover:text-[#e5a436] inline-flex items-center" data-id="element-1095" data-mp="1xpibe9zvsrxn">
              Residential Landlord/Tenant Act
              <ExternalLink className="w-5 h-5 ml-2" data-id="element-1096" data-mp="1expj6hsmzaqz" />
            </a>
          </h2>

          <p className="text-base text-gray-700" data-id="element-1097" data-mp="2uepoquqcjuqh">
            This is the text of the Arizona Statute that provides the rights and
            obligations of landlords and tenants in residential properties.
          </p>
        </div>

        {/* Other Useful Sites Section */}
        <div className="mb-12" data-id="element-1098" data-mp="now3plvfghxl">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1099" data-mp="spaf9dw8ma0d">
            Other Useful Sites-click for links:
          </h2>

          {/* Federal Government/National Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1100" data-mp="12fmvwv0xlj18">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1101" data-mp="12hg4wgz0ofce">
              Federal Government/National Sites
            </h3>
            <ul className="space-y-3" data-id="element-1102" data-mp="1bfs251ue2bdt">
              <li className="text-base" data-id="element-1103" data-mp="1beqgk3fqy6hu">
                <a href="https://www.consumerfinance.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1104" data-mp="1gfedt6ukjjki">
                  Consumer Financial Protection Bureau (CFPB)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1105" data-mp="3n52j7g0xypm4" />
                </a>
              </li>
              <li className="text-base" data-id="element-1106" data-mp="24aznumsnd0r9">
                <a href="https://www.hud.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1107" data-mp="24c10uwt83xbm">
                  US Department of Housing and Urban Development (HUD)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1108" data-mp="1qhi4b1zyno18" />
                </a>
              </li>
              <li className="text-base" data-id="element-1109" data-mp="2n798jsy20pk8">
                <a href="https://www.donotcall.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1110" data-mp="2j7qpz3tpgqkk">
                  National Do Not Call Registry
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1111" data-mp="12us322vfrxho" />
                </a>
              </li>
              <li className="text-base" data-id="element-1112" data-mp="xtm9y3xv687m">
                <a href="https://www.va.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1113" data-mp="xwqljmdns68b">
                  Department of Veterans Affairs
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1114" data-mp="3856jcuohmcxk" />
                </a>
              </li>
              <li className="text-base" data-id="element-1115" data-mp="33aafmx9w214m">
                <a href="https://www.hudhomestore.com/Home/Index.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1116" data-mp="3h38rdu6n25uc">
                  HUD Home Store
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1117" data-mp="3m2ldgcpor8vv" />
                </a>{' '}
                <span className="text-gray-600" data-id="element-1118" data-mp="1wnn8cg4o15og">
                  (to sell HUD foreclosed properties, check with your broker)
                </span>
              </li>
            </ul>
          </div>

          {/* State of Arizona Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1119" data-mp="784baz521xrb">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1120" data-mp="c4ulx6y3c15c">
              State of Arizona Sites
            </h3>
            <ul className="space-y-3" data-id="element-1121" data-mp="3tlumg4ua55ke">
              <li className="text-base" data-id="element-1122" data-mp="2g2y9b02c308">
                <a href="https://az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1123" data-mp="2f1f0j8w8a7f">
                  State of Arizona
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1124" data-mp="3aobbuws6bevv" />
                </a>
              </li>
              <li className="text-base" data-id="element-1125" data-mp="3fm32zokzuwz0">
                <a href="https://difi.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1126" data-mp="3fmuzd1mf0yqc">
                  Department of Financial Institutions
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1127" data-mp="1cfdvjggkg707" />
                </a>
              </li>
              <li className="text-base" data-id="element-1128" data-mp="17doijv9s9j9h">
                <a href="http://www.azdeq.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1129" data-mp="12fmwr2kz35ub">
                  Arizona Department of Environmental Quality
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1130" data-mp="1q57i1s4lmf6r" />
                </a>
              </li>
              <li className="text-base" data-id="element-1131" data-mp="1le93awz9dp5m">
                <a href="https://azdohs.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1132" data-mp="1lcxxysq609ce">
                  Arizona Department of Homeland Security
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1133" data-mp="2928q5ltg8vex" />
                </a>
              </li>
              <li className="text-base" data-id="element-1134" data-mp="2hesmvh4ta9hz">
                <a href="https://roc.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1135" data-mp="2le1cc9stjl7q">
                  Arizona Registrar of Contractors
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1136" data-mp="30cd9ehk3svzf" />
                </a>
              </li>
              <li className="text-base" data-id="element-1137" data-mp="34cx65k0rlxl1">
                <a href="http://www.azcc.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1138" data-mp="34bvt5a06v10o">
                  Arizona Corporation Commission
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1139" data-mp="3j3wd6qlyce2i" />
                </a>
              </li>
              <li className="text-base" data-id="element-1140" data-mp="3o1xtj3rztzaa">
                <a href="https://azsos.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1141" data-mp="onf5wjjnosx7">
                  Arizona Secretary of State
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1142" data-mp="yf1iaj7qcy1j" />
                </a>
              </li>
              <li className="text-base" data-id="element-1143" data-mp="tghtmb1r585h">
                <a href="https://www.azag.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1144" data-mp="5nrksap5b4zf">
                  Arizona Attorney General
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1145" data-mp="ane5143e5lhq" />
                </a>
              </li>
            </ul>
          </div>

          {/* Arizona County Sites */}
          <div className="bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1146" data-mp="1m2t3ydf5unfh">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1147" data-mp="1m4vr8poxi2gi">
              Arizona County Sites (partial list)
            </h3>
            <ul className="space-y-3" data-id="element-1148" data-mp="1yl5910hrbfzu">
              <li className="text-base" data-id="element-1149" data-mp="1ym6i4zf7psex">
                <a href="http://www.coconino.az.gov/119/Assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1150" data-mp="1jo5qwipa44r4">
                  Coconino County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1151" data-mp="2hcfvn5gg96lx" />
                </a>
              </li>
              <li className="text-base" data-id="element-1152" data-mp="22na0ptona2ju">
                <a href="http://www.coconino.az.gov/319/Recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1153" data-mp="22mgz174jm38k">
                  Coconino County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1154" data-mp="304h3gxb7c77h" />
                </a>
              </li>
              <li className="text-base" data-id="element-1155" data-mp="39wa6nmt6pauy">
                <a href="https://mcassessor.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1156" data-mp="34yrwxu7cerlw">
                  Maricopa County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1157" data-mp="2qzsa8s3e4msd" />
                </a>
              </li>
              <li className="text-base" data-id="element-1158" data-mp="2m8julebgw56r">
                <a href="https://recorder.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1159" data-mp="2m7h3p6e5a2qu">
                  Maricopa County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1160" data-mp="28avcge8sbc5e" />
                </a>
              </li>
              <li className="text-base" data-id="element-1161" data-mp="23c0sh8z2zhjp">
                <a href="http://www.asr.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1162" data-mp="isopamelduo5">
                  Pima County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1163" data-mp="wry6npejautp" />
                </a>
              </li>
              <li className="text-base" data-id="element-1164" data-mp="26zapl59d6h">
                <a href="https://www.recorder.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1165" data-mp="38kvnzsdi2g">
                  Pima County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1166" data-mp="duwzbxxiciml" />
                </a>
              </li>
              <li className="text-base" data-id="element-1167" data-mp="3de7o33vcgc8n">
                <a href="http://www.pinalcountyaz.gov/Assessor/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1168" data-mp="3hhdp9x3lnd89">
                  Pinal County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1169" data-mp="2ktipe6uw8gbd" />
                </a>
              </li>
              <li className="text-base" data-id="element-1170" data-mp="2fsv29w9scjmf">
                <a href="http://www.pinalcountyaz.gov/Recorder/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1171" data-mp="2fw0pf5yutbfi">
                  Pinal County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1172" data-mp="2yjvxc97sbv0p" />
                </a>
              </li>
              <li className="text-base" data-id="element-1173" data-mp="3cjf5h20lj6d0">
                <a href="http://www.yumacountyaz.gov/government/assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1174" data-mp="3ck6pdfktzfng">
                  Yuma County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1175" data-mp="3w3clz149fhj2" />
                </a>
              </li>
              <li className="text-base" data-id="element-1176" data-mp="3i8a73ohfqhu4">
                <a href="http://www.yumacountyaz.gov/government/recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1177" data-mp="3n4923ux9qy3i">
                  Yuma County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1178" data-mp="2zh0x7e3r5r20" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}